import { useRef, useEffect } from 'react';
import { useSendEvent } from '../use-send-event';
export var usePageViewEvent = function usePageViewEvent() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'page-view' : _ref$name,
    data = _ref.data;
  var firstRender = useRef(true);
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  useEffect(() => {
    if (firstRender.current) {
      sendEvent(name, data);
      firstRender.current = false;
    }
  });
};